import { Box } from '@podiumhq/design-system';
import useShouldScrollToElement from 'hooks/useShouldScrollToElement';

export const ErrorNotification = ({
  errorMessage,
  shouldScrollToError,
  ...props
}) => {
  const errorBoxStyles = {
    backgroundColor: 'red.lightest',
    borderRadius: '12px',
    color: 'red.base',
    marginBottom: '16px',
    padding: '14px 12px',
    ...props,
  };

  const scrollRef = useShouldScrollToElement(
    shouldScrollToError && !!errorMessage
  );

  return !!errorMessage ? (
    <Box ref={scrollRef} {...errorBoxStyles}>
      {errorMessage}
    </Box>
  ) : null;
};
